export const Picture = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    className="stroke-fg-1"
    {...props}>
    <path
      d="M6.19596 27.6372L14.9913 18.8418C15.5194 18.3138 15.7834 18.0498 16.0878 17.9509C16.3556 17.8639 16.6441 17.8639 16.9119 17.9509C17.2163 18.0498 17.4803 18.3138 18.0083 18.8418L26.7451 27.5786M19.1665 20L22.9913 16.1752C23.5194 15.6471 23.7834 15.3831 24.0878 15.2842C24.3556 15.1972 24.6441 15.1972 24.9119 15.2842C25.2163 15.3831 25.4803 15.6471 26.0083 16.1752L29.8332 20M13.8332 12C13.8332 13.4728 12.6393 14.6667 11.1665 14.6667C9.69374 14.6667 8.49984 13.4728 8.49984 12C8.49984 10.5272 9.69374 9.33333 11.1665 9.33333C12.6393 9.33333 13.8332 10.5272 13.8332 12ZM9.5665 28H23.4332C25.6734 28 26.7935 28 27.6491 27.564C28.4018 27.1805 29.0137 26.5686 29.3972 25.816C29.8332 24.9603 29.8332 23.8402 29.8332 21.6V10.4C29.8332 8.15979 29.8332 7.03969 29.3972 6.18404C29.0137 5.43139 28.4018 4.81947 27.6491 4.43597C26.7935 4 25.6734 4 23.4332 4H9.5665C7.32629 4 6.20619 4 5.35054 4.43597C4.59789 4.81947 3.98597 5.43139 3.60248 6.18404C3.1665 7.03969 3.1665 8.15979 3.1665 10.4V21.6C3.1665 23.8402 3.1665 24.9603 3.60248 25.816C3.98597 26.5686 4.59789 27.1805 5.35054 27.564C6.20619 28 7.32629 28 9.5665 28Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
